export default __webpack_public_path__ + "static/media/bg_03.5257f143.png";